var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreatmentConfirmed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFB201",
    fillOpacity: 0.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3511_6328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.729 11.9553V10.8343C16.729 10.4549 17.0365 10.1431 17.4104 10.1431H18.5156C18.8896 10.1431 19.1971 10.4549 19.1971 10.8343V11.9553",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9669 14.0461C18.7379 14.0461 19.363 13.4121 19.363 12.63C19.363 11.8479 18.7379 11.2139 17.9669 11.2139C17.1958 11.2139 16.5708 11.8479 16.5708 12.63C16.5708 13.4121 17.1958 14.0461 17.9669 14.0461Z",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91463 17.1647C10.6857 17.1647 11.3107 16.5307 11.3107 15.7486C11.3107 14.9665 10.6857 14.3325 9.91463 14.3325C9.1436 14.3325 8.51855 14.9665 8.51855 15.7486C8.51855 16.5307 9.1436 17.1647 9.91463 17.1647Z",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0607 13.3826L16.9569 13.1719H18.9524L18.8028 13.4525L18.3656 13.739H17.5637L17.0607 13.3826Z",
    fill: "#0079AB",
    stroke: "#263077",
    strokeWidth: 0.444444
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6926 21.8597C14.5015 21.8597 14.3104 21.7923 14.1608 21.6742L9.55706 18.075C9.16649 17.7631 8.59311 17.839 8.28564 18.2436L8.18592 18.37C7.88676 18.7662 7.95324 19.3478 8.35212 19.6597L13.4046 23.6045C13.6123 23.7731 13.8699 23.8574 14.1359 23.8574H21.9722C22.2464 23.8574 22.4874 23.7478 22.6702 23.5624C22.8447 23.3854 22.961 23.1325 22.961 22.8543C22.961 22.3064 22.5206 21.8513 21.9722 21.8513H14.6926V21.8597Z",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2687 21.7163C14.3435 21.7753 14.4432 21.809 14.5429 21.809L16.9694 21.8596C17.1107 21.8596 17.252 21.8259 17.3766 21.7669L18.7478 21.1094C18.9555 21.0082 19.1965 20.983 19.4209 21.0504L22.1133 21.7837C22.3792 21.8596 22.6618 21.7416 22.803 21.4971C22.9942 21.1684 22.8529 20.7469 22.5039 20.6036L19.2214 19.2213C18.9555 19.1117 18.6647 19.1117 18.3987 19.2128L16.5789 19.9293C16.5207 19.9546 16.4542 19.963 16.396 19.963H14.9335C14.7756 19.963 14.6177 19.9124 14.493 19.8113L11.9834 17.8557C11.8339 17.7377 11.651 17.6787 11.4682 17.6787C11.2189 17.6787 10.9696 17.7967 10.8034 18.0074C10.5209 18.3783 10.5874 18.9094 10.953 19.196L14.2687 21.7163Z",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8394 18.5133L15.8725 15.3945C16.1052 15.15 16.4293 15.0151 16.77 15.0151H19.2297C19.5621 15.0151 19.8862 15.15 20.1272 15.3945L22.2379 17.5692C22.4208 17.7546 22.454 18.0496 22.3127 18.2688L21.1909 20.0389",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4712 17.0298L20.1361 17.7547C20.3107 17.9401 20.3273 18.2267 20.186 18.4375L19.5626 19.3562",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.061 19.4657L16.1053 17.2993C16.1967 17.2066 16.3546 17.2656 16.3546 17.4005V19.963",
    stroke: "#263077",
    strokeWidth: 0.444444,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3511_6328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentConfirmed);
export default __webpack_public_path__ + "static/media/treatment_confirmed.6c84aa7eb02d43843423970718316b66.svg";
export { ForwardRef as ReactComponent };